import { useMemo, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../../lib/helpers';

interface FormScriptsProps {
  /**
   * Generated form URL
   */
  formUrl?: string;
  /**
   * Component test id
   */
  testId?: string;
}

const FormScripts = ({ formUrl, testId = '' }: FormScriptsProps) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState<string>();

  const scripts = useMemo(
    () => [
      {
        translationKey: 'Styles',
        script:
          '<link rel="stylesheet" ' +
          'href="https://flotiq-form-generator-styles.s3.amazonaws.com/flotiq-form-default.css"/>',
      },
      {
        translationKey: 'Form',
        script: '<flotiq-form/>',
      },
      {
        translationKey: 'Script',
        script: `<script src="${formUrl}" async></script>`,
      },
    ],
    [formUrl],
  );

  return (
    <div className="space-y-5">
      {scripts.map(({ translationKey, script }) => {
        return (
          <div key={translationKey}>
            <p className="block mb-2">
              {t(
                `ContentTypeForm.FormGenerator.ScriptDescription.${translationKey}`,
              )}
            </p>
            <CopyToClipboard
              text={script}
              onCopy={() => {
                setIsCopied(translationKey);
              }}
            >
              <code
                className="block cursor-copy rounded-lg p-2 bg-slate-200 dark:bg-slate-600"
                {...getTestProps(testId, `scripts-${translationKey}`)}
              >
                {script}
              </code>
            </CopyToClipboard>
            <span
              className="uppercase text-xs tracking-widest text-slate-600 dark:text-slate-400"
              {...getTestProps(testId, `scripts-${translationKey}-copy`)}
            >
              {isCopied === translationKey
                ? t('ContentTypeForm.FormGenerator.ScriptDescription.Copied')
                : t('ContentTypeForm.FormGenerator.ScriptDescription.Copy')}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default FormScripts;
